module.exports = __webpack_public_path__ + "static/img/ts.png";